import { render, staticRenderFns } from "./single_file_linked_text_field.vue?vue&type=template&id=3e1fb954&lang=pug"
import script from "./single_file_linked_text_field.vue?vue&type=script&lang=js"
export * from "./single_file_linked_text_field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports